export default __webpack_public_path__ + "static/media/tomasSanchez.ed4ad986.jpg";